module.exports = __webpack_public_path__ + "img/smart.7d92f6ef.svg";